// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__3_jwy","open":"sidebar_open__21FyN","navbar":"sidebar_navbar__3a2-l"};